// src/pages/HomePage.js
import React from "react";
import { motion } from "framer-motion";
import { Button } from "../components/UI/button";
import { Card, CardContent } from "../components/UI/card";
import BannerCarousel from "../components/BannerCarousel";

const HomePage = () => {
  return (
    <div className="bg-black text-white min-h-screen">
      <BannerCarousel />
      <main className="max-w-7xl mx-auto px-6 py-10">
        <motion.section
          className="bg-gray-800 p-6 rounded-2xl shadow-md"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
        >
          <h2 className="text-2xl font-semibold text-green-500">About Us</h2>
          <p className="text-gray-300 mt-4">
            Team CodeMe is a hybrid marketing and software development company. We specialize in creating tailored
            solutions that bridge the gap between technology and creativity, helping businesses thrive in a
            digital-first world.
          </p>
        </motion.section>

        <section className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          <Card className="bg-gray-800 hover:shadow-lg transition-shadow">
            <CardContent>
              <h3 className="text-xl font-bold text-green-500">Custom Software Development</h3>
              <p className="text-gray-300 mt-2">
                Build robust applications tailored to your business needs using the latest technologies.
              </p>
              <Button variant="outline" className="mt-4">
                Learn More
              </Button>
            </CardContent>
          </Card>

          <Card className="bg-gray-800 hover:shadow-lg transition-shadow">
            <CardContent>
              <h3 className="text-xl font-bold text-green-500">Integrated Marketing Services</h3>
              <p className="text-gray-300 mt-2">
                From SEO to social media management, we cover all your marketing needs.
              </p>
              <Button variant="outline" className="mt-4">
                Learn More
              </Button>
            </CardContent>
          </Card>

          <Card className="bg-gray-800 hover:shadow-lg transition-shadow">
            <CardContent>
              <h3 className="text-xl font-bold text-green-500">Join the Team</h3>
              <p className="text-gray-300 mt-2">
                Be a part of a dynamic team shaping the future of technology and marketing.
              </p>
              <Button variant="outline" className="mt-4">
                Apply Now
              </Button>
            </CardContent>
          </Card>
        </section>
        <motion.section
          className="bg-gray-800 p-6 rounded-2xl shadow-md mt-10"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          <h2 className="text-2xl font-semibold text-green-500">Stay Updated</h2>
          <p className="text-gray-300 mt-4">
            Subscribe to our newsletter to get the latest updates on events, workshops, and more.
          </p>
          <div className="mt-6">
            <input
              type="email"
              placeholder="Enter your email"
              className="p-2 rounded-md w-full md:w-1/2 bg-gray-700 text-white border border-gray-600"
            />
            <Button variant="default" className="mt-4">
              Subscribe
            </Button>
          </div>
        </motion.section>

        <motion.section
          className="bg-gray-800 p-6 rounded-2xl shadow-md mt-10"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          <h2 className="text-2xl font-semibold text-green-500">Workshops for Students and Freshers</h2>
          <p className="text-gray-300 mt-4">
            Join our workshops to learn, grow, and start your journey into technology and marketing.
          </p>
          <div className="mt-6">
            <Button variant="default">Join a Workshop</Button>
          </div>
        </motion.section>
      </main>
    </div>
  );
};

export default HomePage;